import { render, staticRenderFns } from "./detalleSesion.vue?vue&type=template&id=38223fd6&"
import script from "./detalleSesion.vue?vue&type=script&lang=js&"
export * from "./detalleSesion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports